import {enumType} from 'common/enumType';

export const FileCompletionStatus = enumType({
   CANCELLED: 'Cancelled',
   ERROR: 'Failure',
   NOT_PROCESSED: 'Not Processed',
   SUCCESSFUL: 'Successful',
   TERMINATED: 'Terminated',
   WARNING: 'Warning',
});
